import React from "react";
import { useHistory } from "react-router-dom";
import {
  LoginOutlined,
  UserAddOutlined,
  SettingOutlined,
  GroupOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { Menu, Avatar } from "antd";
import blogLogo from "./../../assets/images/blogging.png";
import { useSelector, useDispatch } from "react-redux";
import { userAuthActions } from "./../../redux/actions/actionCreator";
const { SubMenu } = Menu;

export default function HorizontalNavbar() {
  const router = useHistory();
  const userState = useSelector((st) => st.user);
  const dispatch = useDispatch();

  return (
    <div>
      <Menu selectedKeys={"logo"} mode="horizontal" theme="dark">
        <Menu.Item className="unhoverable-menu-item">
          <a onClick={() => router.push("/")}>
            <Avatar src={blogLogo} shape="square" /> &nbsp; Blog App
          </a>
        </Menu.Item>

        {userState.isLoggedIn ? (
          <>
            <SubMenu
              key="SubMenu"
              icon={<Avatar src={userState.user.imagePath} shape="circle" />}
              title={" " + userState.user.userName}
              className="float-right unhoverable-menu-item"
            >
              <Menu.Item key="userProfile" icon={<SettingOutlined />}>
                <a onClick={() => router.push("/user/profile")}>User Profile</a>
              </Menu.Item>
              <Menu.Item key="userPosts" icon={<GroupOutlined />}>
                <a onClick={() => router.push("/user/posts")} >User Posts</a>
              </Menu.Item>
              <Menu.Item
                key="logout"
                icon={<LoginOutlined />}
                onClick={() => dispatch(userAuthActions.logout())}
              >
                Logout
              </Menu.Item>
            </SubMenu>
            <Menu.Item
              key="newPost"
              icon={<FormOutlined />}
              className="float-right"
            >
              <a onClick={() => router.push("/posts/new")}>New Post</a>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item
              key="login"
              icon={<LoginOutlined />}
              className="float-right"
            >
              <a onClick={() => router.push("/login")}>Login</a>
            </Menu.Item>
            <Menu.Item
              key="logout"
              icon={<UserAddOutlined />}
              className="float-right"
            >
              {/* <a href="/signup">Signup</a> */}
              <a onClick={() => router.push("/signup")}>New Post</a>
            </Menu.Item>
          </>
        )}
      </Menu>
    </div>
  );
}
